import React, { useState } from 'react';
import { Form } from 'antd';
import { SketchPicker, ColorResult } from 'react-color';
import styled from '@emotion/styled';
import { ButtonActionPage } from '../../atoms';

interface ColorPikerProps {
  title?: string;
  color?: string;
  name?: string;
  onColorChanged: Function;
}

const ColorPicker = (props: ColorPikerProps) => {
  const { title, color, name, onColorChanged } = props;
  const [showColorPicker, setShowColorPicker] = useState(false);

  const onChange = (value: ColorResult) => {
    onColorChanged(value?.hex);
  };

  return (
    <StyledWrapper>
      <Form.Item name={name} label={title}>
        <ButtonActionPage text="Pick" id="1" className="btn-pick-color" onClick={() => setShowColorPicker(true)} />
        {showColorPicker && (
          <div className="popover">
            <div
              className="cover"
              onClick={() => setShowColorPicker(false)}
              onKeyDown={() => setShowColorPicker(false)}
              role="button"
              tabIndex={0}
            >
              {' '}
            </div>
            <SketchPicker color={color} onChange={onChange} />
          </div>
        )}
      </Form.Item>
    </StyledWrapper>
  );
};

export default ColorPicker;

const StyledWrapper = styled.div`
  .popover {
    position: absolute;
    z-index: 9999;
    bottom: 0;
    top: 0;
    left: 20%;
  }

  .cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .sketch-picker {
    cursor: pointer;
  }

  & .ant-slider:hover .ant-slider-rail,
  & .ant-slider-rail {
    background-color: #6e6e6e;
  }
`;
